import { render } from "./symbolTagLabel.vue?vue&type=template&id=053b2df6&scoped=true"
import script from "./symbolTagLabel.vue?vue&type=script&lang=js"
export * from "./symbolTagLabel.vue?vue&type=script&lang=js"

import "./symbolTagLabel.vue?vue&type=style&index=0&id=053b2df6&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053b2df6"]])

export default __exports__